import cBillingForm from '#themes/default/default/components/billingForm/billingForm.js';
import cCardInput from '#themes/default/default/components/cardInput/cardInput.js';
import cProvidersElement from '#themes/default/default/components/providersElement/providersElement.js';

import template from './bancontact.html' with { type: 'html' };

export default {
	name: 'CBancontact',
	components: {
		cBillingForm,
		cCardInput,
		cProvidersElement
	},
	props: {
		customer: {
			type: Object,
			default: () => null
		},
		form: {
			type: Object,
			default: () => null
		},
		isNewMethod: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		providerAccount: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			cardExpirationHasError: false,
			cardNumberHasError: false,
			isEmpty: true,
			cardnumberIsEmpty: true,
			cardexpirationIsEmpty: true
		};
	},
	computed: {
		isSelected() {
			return this.selectedPayment.id === 'bancontact';
		}
	},
	watch: {
		form() {
			// Set an error if the from has been submitted without interacting with Bancontact field
			const isCompleted = this.form.bancontact?.completed;
			if (!this.form.bancontact?.touched && this.form.bancontact?.submitted) {
				this.cardNumberHasError = !isCompleted;
			}
		},
		isSelected() {
			this.cardExpirationHasError = false;
			this.cardNumberHasError = false;
			this.isEmpty = true;
			this.cardnumberIsEmpty = true;
			this.cardexpirationIsEmpty = true;
		}
	},
	methods: {
		async setInputStatus({ data: { elementType, empty, error, complete }, name }) {
			// Manage input statuses
			const emptyElementSelector = `${elementType}IsEmpty`;
			if (name === 'blur' && this[emptyElementSelector] || error) {
				this.changeInputStatus(elementType, true);
			}
			if (typeof empty !== 'undefined') {
				this[emptyElementSelector] = empty;
				this.isEmpty = elementType === 'cardnumber' ? empty : this.isEmpty;
			}
			if (complete) {
				await this.$nextTick();
				this.changeInputStatus(elementType, false);
			}
		},
		changeInputStatus(elementType, hasError) {
			// Change bancontact touched status to true after it's been interacted with
			if (!this.form.bancontact?.touched) {
				this.$store.commit('SET_FORM', {
					bancontact: {
						touched: true
					}
				});
			}
			if (elementType === 'cardnumber') {
				this.cardNumberHasError = hasError;
			} else if (elementType === 'cardexpiration') {
				this.cardExpirationHasError = hasError;
			}
		},

		/**
		 * Handle input "return" event and submit the form
		 * @todo We should refactor this method and use some "global" methods or new models to handle this
		 */
		onProvidersElementSubmit() {
			const submitButton = document.querySelector('.t-paymentInfo_submit');
			submitButton.click();
		}
	},
	template
};
